import React, { FC } from 'react';
import styled from 'styled-components';
import { Base } from 'styled';
import EmbeddedInterview from 'styled/components/modules/EmbeddedInterview';
import QuizTextModule from 'components/modules/QuizTextModule';

import type { QuizModule } from 'types';

interface Props {
  modules: QuizModule[];
}

const QuizContainer = styled(Base)`
  padding-bottom: 3rem;
`;

const Module = ({ module }: { module: QuizModule; modules: QuizModule[] }) => {
  if (!module) {
    return null;
  }

  switch (module.type) {
    case 'textModule':
      return (
        <QuizTextModule
          module={module}
          hasWrapper={false}
          calloutVariant={module.moduleOptions.callout.variant}
        />
      );
    case 'embeddedInterview':
      return <EmbeddedInterview key={module.id} module={module} />;
    default:
      return null;
  }
};

const QuizModuleSwitch: FC<Props> = ({ modules }) => {
  return (
    <QuizContainer>
      {modules.map((module) => (
        <Module key={module?.id} module={module} modules={modules} />
      ))}
    </QuizContainer>
  );
};

export default QuizModuleSwitch;
